


































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { AccountProfileComponents } from '@/enums/AccountProfileComponents';
import AccountProfileBillingAddress from '@/components/account/AccountProfileBillingAddress.vue';
import { BillingAddress } from '@/interfaces/BillingAddress';
import { UserData } from '@/interfaces/UserData';
import { Action } from 'vuex-class';

@Component({
    name: 'BillingProfileView',
    components: {
        AccountProfileBillingAddress,
    },
})
export default class BillingProfileView extends Vue {
    @Prop({required: true}) public billingAddresses!: BillingAddress[];
    @Prop({required: true}) public userData!: UserData;

    @Action('user/deleteBillingAddress') public deleteBillingAddress!: (id: number) => Promise<unknown>;

    protected dialogVisible = false;
    @Action('user/getBillingAddresses') private getBillingAddresses!: () => void;
    private activeAddress: BillingAddress | null = null;

    protected toggleComponent(componentName: keyof typeof AccountProfileComponents) {
        this.$emit('toggle-component', AccountProfileComponents[componentName], this.activeAddress);
    }

    protected async deleteAddress() {
        // todo - api call
        if (this.activeAddress) {
            await this.deleteBillingAddress(this.activeAddress.id);
            await this.getBillingAddresses();
        }
        this.closeDialog();
    }

    protected openDialog(billingAddress: BillingAddress) {
        this.activeAddress = billingAddress;
        this.dialogVisible = true;
    }

    protected closeDialog() {
        this.activeAddress = null;
        this.dialogVisible = false;
    }

    protected editAddress(billingAddress: BillingAddress) {
        this.activeAddress = billingAddress;
        this.toggleComponent('AddAddress');
    }

    protected navigateToComponent(componentName: string) {
        this.$emit('navigate', componentName);
    }

    protected mounted() {
        if (this.userData.firstName !== '' && this.billingAddresses.length === 0) {
            this.toggleComponent('AddAddress');
        }
    }
}
